import { Service } from 'kubernetes-types/core/v1';
import { HorizontalPodAutoscaler } from 'kubernetes-types/autoscaling/v2';

import { AppKind, AppType, DeploymentType } from '../../types';

export interface ApplicationRowData extends Application {
  KubernetesApplications?: Array<Application>;
}

export interface ApplicationPod {
  Name: string;
  ContainerName: string;
  Image: string;
  ImagePullPolicy: string;
  Status: string;
  NodeName: string;
  PodIP: string;
  Uid: string;
  Resource: Record<string, unknown>;
  CreationDate: string;
}

export interface Application {
  Id: string;
  Name: string;
  Image: string;
  Containers?: Array<unknown>;
  Services?: Array<Service>;
  CreationDate: string;
  ApplicationOwner?: string;
  StackName?: string;
  StackKind?: string;
  ResourcePool: string;
  ApplicationType: AppType;
  Kind: AppKind;
  Metadata?: {
    labels: Record<string, string>;
    annotations: Record<string, string>;
  };
  Status: 'Ready' | string;
  TotalPodsCount: number;
  RunningPodsCount: number;
  DeploymentType: DeploymentType;
  Pods?: Array<ApplicationPod>;
  Configurations?: Array<{
    Data?: object;
    Kind: ConfigKind;
    ConfigurationOwner: string;
  }>;
  LoadBalancerIPAddress?: string;
  PublishedPorts?: Array<{
    IngressRules: Array<{
      Host: string;
      IP: string;
      Path: string;
      TLS: Array<{
        hosts: Array<string>;
      }>;
    }>;
    Port: number;
  }>;
  Resource?: {
    CpuLimit?: number;
    CpuRequest?: number;
    MemoryLimit?: number;
    MemoryRequest?: number;
  };
  HorizontalPodAutoscaler?: HorizontalPodAutoscaler;
  CustomResourceMetadata?: {
    apiVersion: string;
    name: string;
    kind: string;
    plural: string;
  };
}

export enum ConfigKind {
  ConfigMap = 1,
  Secret,
}
